import {
  Types,
  DataTypes,
  MotivosFaltasActionTypes,
  MotivosFaltasAddOrEditDTO,
} from "./types";
import customToast from "~/components/Toast/index";
/**
 * Reducers
 */
const INITIAL_STATE: DataTypes = {
  data: [],
  loadingData: false,
  loadingAction: false,
  success: false,
  error: false,
  itemSelected: {
    item: null,
    error: false,
    loading: false,
    success: false,
  },
};

/**
 * Actions
 */

export const Creators = {
  getMotivosFaltas: (search?: string): MotivosFaltasActionTypes => {
    return {
      type: Types.REQUEST_LOAD_MOTIVOS_FALTAS,
      search,
    };
  },

  getMotivoFaltaById: (idMotivoFalta: number): MotivosFaltasActionTypes => ({
    type: Types.REQUEST_LOAD_MOTIVO_FALTA_BY_ID,
    idMotivoFalta,
  }),

  addMotivoFalta: (
    motivo: MotivosFaltasAddOrEditDTO
  ): MotivosFaltasActionTypes => ({
    type: Types.REQUEST_ADD_MOTIVO_FALTA,
    payload: motivo,
  }),

  editMotivoFalta: (
    motivo: MotivosFaltasAddOrEditDTO
  ): MotivosFaltasActionTypes => ({
    type: Types.REQUEST_EDIT_MOTIVO_FALTA,
    payload: motivo,
  }),

  delMotivoFalta: (idMotivoFalta: number): MotivosFaltasActionTypes => ({
    type: Types.REQUEST_DEL_MOTIVO_FALTA,
    idMotivoFalta,
  }),
};

export default function motivoFaltaReducer(
  state = INITIAL_STATE,
  action: MotivosFaltasActionTypes
): DataTypes {
  switch (action.type) {
    // LOAD
    case Types.REQUEST_LOAD_MOTIVOS_FALTAS:
      return {
        ...state,
        loadingData: true,
        error: false,
        success: false,
        itemSelected: { ...state.itemSelected, item: null },
      };
    case Types.SUCCESS_LOAD_MOTIVOS_FALTAS:
      return {
        ...state,
        loadingData: false,
        error: false,
        success: true,
        data: action.payload,
      };
    case Types.FAILURE_LOAD_MOTIVOS_FALTAS:
      customToast.error(action.message);
      return {
        ...state,
        data: [],
        loadingData: false,
        success: false,
        error: true,
      };

    //LOAD BY ID
    case Types.REQUEST_LOAD_MOTIVO_FALTA_BY_ID:
      return {
        ...state,
        itemSelected: {
          item: null,
          loading: true,
          success: false,
          error: false,
        },
      };
    case Types.SUCCESS_LOAD_MOTIVO_FALTA_BY_ID:
      return {
        ...state,
        itemSelected: {
          item: action.payload,
          loading: false,
          success: true,
          error: false,
        },
      };
    case Types.FAILURE_LOAD_MOTIVO_FALTA_BY_ID:
      customToast.error(action.message);
      return {
        ...state,
        itemSelected: {
          item: null,
          loading: false,
          success: false,
          error: true,
        },
      };

    // ADD
    case Types.REQUEST_ADD_MOTIVO_FALTA:
      return { ...state, loadingAction: true, error: false, success: false };
    case Types.SUCCESS_ADD_MOTIVO_FALTA:
      return {
        ...state,
        loadingAction: false,
        error: false,
        success: true,
        data: [...state.data, action.payload],
      };
    case Types.FAILURE_ADD_MOTIVO_FALTA:
      customToast.error(action.message);
      return {
        ...state,
        loadingAction: false,
        success: false,
        error: true,
      };

    // EDIT
    case Types.REQUEST_EDIT_MOTIVO_FALTA:
      return { ...state, loadingAction: true, error: false, success: false };
    case Types.SUCCESS_EDIT_MOTIVO_FALTA:
      return {
        ...state,
        loadingAction: false,
        error: false,
        success: true,
        data: state.data.map((item) => {
          if (item.idMotivoFalta === action.payload.idMotivoFalta) {
            return action.payload;
          }
          return item;
        }),
      };
    case Types.FAILURE_EDIT_MOTIVO_FALTA:
      customToast.error(action.message);
      return {
        ...state,
        loadingAction: false,
        success: false,
        error: true,
      };

    // // DEL
    case Types.REQUEST_DEL_MOTIVO_FALTA:
      return { ...state, error: false, success: false };
    case Types.SUCCESS_DEL_MOTIVO_FALTA:
      return {
        ...state,
        error: false,
        success: true,
        data: state.data.filter(
          (item) => item.idMotivoFalta !== action.idMotivoFalta
        ),
      };
    case Types.FAILURE_DEL_MOTIVO_FALTA:
      customToast.error(action.message);
      return {
        ...state,
        success: false,
        error: true,
      };

    default:
      return state;
  }
}
